import { useCallback } from 'react';
import { usePlayerContext } from '../PlayerContext';
import { useStore } from '../hooks/useStore';
import { PlayIcon, PauseIcon } from '../icons';
import { Tooltip } from './Tooltip';
import styles from './PlayButton.module.css';

export function PlayButton() {
  const { store, eventBus } = usePlayerContext();
  const isPlaying = useStore(store, useCallback(s => s.isPlaying, []));

  const handleClick = useCallback(() => {
    eventBus.emit(isPlaying ? 'pause' : 'play');
  }, [eventBus, isPlaying]);

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={`${styles.btn}${isPlaying ? ` ${styles.playing}` : ''}`}
        onClick={handleClick}
        aria-label={isPlaying ? 'Пауза' : 'Воспроизвести'}
        data-testid="play-button"
      >
        <span className={styles.iconPlay}><PlayIcon /></span>
        <span className={styles.iconPause}><PauseIcon /></span>
      </button>
      <Tooltip label={isPlaying ? 'Пауза' : 'Воспроизвести'} shortcuts={['Пробел', 'k']}/>
    </div>
  );
}
